import { EMPTY_PATH, LOG_PATH, NURSERY_PATH, PROMOTION_PATH } from "../../../crossconcern/utilities/properties/path.property";
import { NurseryComponent } from "./nursery";
import { NURSERY_ROUTES } from "./nursery/nursery.routes";
import { PRIVATE_LOG_ROUTE, PRIVATE_NURSERY_ROUTE, PRIVATE_PROMOTION_ROUTE } from "../../../crossconcern/utilities/properties/routename.property";
import { PROMOTION_ROUTES } from "./promotion/promotion.routes";
import { PromotionComponent } from "./promotion";
import { LogComponent } from "./log";
import { BackofficeGuardHelper } from "../../../crossconcern/helpers/generic/backofficeguard.helper";
var ɵ0 = { routeName: PRIVATE_NURSERY_ROUTE }, ɵ1 = { routeName: PRIVATE_PROMOTION_ROUTE }, ɵ2 = { routeName: PRIVATE_LOG_ROUTE };
export var BACKOFFICEMAIN_ROUTES = [
    {
        path: EMPTY_PATH,
        pathMatch: "full",
        redirectTo: NURSERY_PATH
    },
    {
        path: NURSERY_PATH,
        component: NurseryComponent,
        canActivate: [
            BackofficeGuardHelper
        ],
        children: NURSERY_ROUTES,
        data: ɵ0
    },
    {
        path: PROMOTION_PATH,
        component: PromotionComponent,
        canActivate: [
            BackofficeGuardHelper
        ],
        children: PROMOTION_ROUTES,
        data: ɵ1
    },
    {
        path: LOG_PATH,
        component: LogComponent,
        canActivate: [
            BackofficeGuardHelper
        ],
        data: ɵ2
    }
];
export { ɵ0, ɵ1, ɵ2 };
